$(function() {
    // Textarea auto resize
    $('textarea.auto-size').textareaAutoSize();

    var autocomplete_list = function (codemirror) {
        var $list = $(codemirror).parent().nextAll(".autocomplete_list").first();
        if ($list == []) {
            $list = $("#autocomplete_list");
        }
        var text = $list.text();
        if ($list && text != "") {
            return text.trim().split(",");
        } else {
            return [];
        }
    };

    $('.language-liquid').each(function () {
        var editor = CodeMirror.fromTextArea(this, {
            extraKeys: {"Ctrl-Space": "autocomplete"},
            mode: "twig",
            theme: "neo_wc",
            lineWrapping: true,
            viewportMargin: Infinity,
            scrollbarStyle: "null",
            autocomplete_list: autocomplete_list(this)
        });
        editor.on("inputRead", function (cm, changeObj) {
            var cm_word = cm.findWordAt(changeObj.from);
            var word = cm.getRange(cm_word.anchor, cm_word.head);
            if (word == "{{") {
                editor.showHint(cm);
            }
        });
    });

    $('.CodeMirror-wrap').addClass("form-control");

    $('a[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
        // Hack to enable Editor Reloading
        $('.CodeMirror:visible').each(function (i, el) {
            el.CodeMirror.refresh();
        });
    });
});
